/**
 * Rounds a number by an interval (not fractional digits)
 *
 * @example
 *
 *   round(35, 30)
 *   //=> 30
 **/
export default function intervalRound(num: number, interval = 1) {
  return Math.round(num / interval) * interval;
}
